import type { ReactNode } from "react";

type Props = {
  text: string;
  callback: () => void;
  id?: string;
  className?: string;
  /** Optional icon to show before the text */
  prefixIcon?: ReactNode;
  /** Optional element to show after the text */
  suffixIcon?: ReactNode;
  /** Whether the button is disabled/locked */
  isLocked?: boolean;
};

const GenericActionButton = ({
  text,
  callback,
  id,
  className,
  prefixIcon,
  suffixIcon,
  isLocked,
}: Props) => {
  return (
    <button
      id={id}
      className={`flex items-center justify-center gap-2 rounded-md p-1 px-6 py-2 text-white shadow-sm transition-[transform,background-color,box-shadow,filter] duration-200 ease-out-soft hover:shadow-md hover:brightness-105 active:scale-[0.97] active:shadow-sm mobile:me-0 mobile:px-16 ${
        isLocked ? "bg-secondary/60" : "bg-secondary"
      } ${className}`}
      onClick={callback}
    >
      {prefixIcon}
      {text}
      {suffixIcon}
    </button>
  );
};

export default GenericActionButton;
